import { CurrencyType, PLN } from '@constants/currencies'
import { PROMOTION_FOR_FREE_PLAN } from '@hooks/useSale'
import { PromotionKey } from '@pages/Checkout/hooks/useGetPromotions'
import { Discount } from '@services/discounts'
import { Badge } from '@ui-kit'
import { Trans } from 'react-i18next'

export const getPromoBadge = ({
  activePromotionKey,
  discount,
  currency
}: {
  activePromotionKey: PromotionKey | undefined
  discount: Discount | undefined
  currency: CurrencyType
}) => {
  if (discount) {
    return (
      <Badge variant='info20-filled' weight={600} isTextUppercase={false}>
        <Trans i18nKey='change.plan.page.special.discount' /> {discount.pricing}{' '}
        {currency}{' '}
        {currency === PLN && (
          <Trans i18nKey='registration.flow.credit.card.step.gross' />
        )}
      </Badge>
    )
  }

  if (activePromotionKey === PROMOTION_FOR_FREE_PLAN) {
    return (
      <Badge variant='warning20-filled' weight={600}>
        <Trans i18nKey='promotion.for.free.plan.50percent.x.1month' />
      </Badge>
    )
  }

  return null
}
